import React, { useState, useEffect } from 'react';
import './incubators.css';
import C2wLogoHolder from '../../../common/C2wHome/incubators/logoHolder';
import { useNavigate } from 'react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';

function C2wIncubators() {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mobileArr = ['flutterSvg', 'flutterSvg2'];
  const backendArr = ['javaLogoSvg', 'springLogoSvg'];
  const webArr = ['reactLogoSvg', 'nodeSvg', 'nextJsSvg', 'jsSvg'];

  // Render a specific slide content
  const renderSlideContent = (index) => {
    if (index === 0) {
      return (
        <div className="C2wProducts_slide_layout slide-incubators-inner">
          <div className="C2wProducts_slide_content">
            <div className="C2wProducts_left_col">
              <div className="product-logo-wrapper">
                <img src="/assets/images/landing/incubators.svg" alt="incubators-logo" className="prod-logo" />
              </div>
              <h2 className="product-title">We Deliver Training & Internship Programs</h2>
              <p className="product-description">
                Live projects | Digital logbook | 1:1 Mentorship | Internship offer letter
              </p>
              <a href="http://incubatorsbycore2web.com/" target="_blank" rel="noopener noreferrer" className="product-cta-link">
                <button className="product-cta-btn">
                  Know More
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 19L19 5M19 5H9M19 5V15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </a>
            </div>

            <div className="C2wProducts_right_col">
              <div className="C2wIncubators_cards_holder">
                {/* Mobile app dev card */}
                <div className="C2wTech_card C2wTech_card1">
                  <div className="C2wTech_cardanimate">
                    <span>Mobile App Development</span>
                    <div className="C2wTech_card_logo_holder">
                      {mobileArr.map((img, idx) => (
                        <C2wLogoHolder key={idx} imgSvg={img} />
                      ))}
                    </div>
                  </div>
                  <img src="/assets/images/landing/incuLeftArrow.svg" className="leftarrow_img" alt="arrow" />
                </div>

                {/* Web dev card */}
                <div className="C2wTech_card C2wTech_card2">
                  <div className="C2wTech_cardanimate">
                    <span>Web Development</span>
                    <div className="C2wTech_card_logo_holder">
                      {webArr.map((img, idx) => (
                        <C2wLogoHolder key={idx} imgSvg={img} />
                      ))}
                    </div>
                  </div>
                  <img src="/assets/images/landing/incuBottomArrow.svg" className="incuBottomArrowSvg" alt="arrow" />
                </div>

                {/* Backend dev card */}
                <div className="C2wTech_card C2wTech_card3">
                  <div className="C2wTech_cardanimate">
                    <span>Backend Development</span>
                    <div className="C2wTech_card_logo_holder">
                      {backendArr.map((img, idx) => (
                        <C2wLogoHolder key={idx} imgSvg={img} />
                      ))}
                    </div>
                  </div>
                  <img src="/assets/images/landing/incuRightArrowSvg.svg" className="incuRightArrowSvg" alt="arrow" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (index === 1) {
      return (
        <div className="C2wProducts_slide_layout slide-superx-inner">
          <div className="C2wProducts_slide_content">
            <div className="C2wProducts_left_col">
              <div className="product-logo-wrapper">
                <img src="/assets/images/landing/superx.svg" alt="superx-logo" className="prod-logo superx-logo-img" />
              </div>
              <h2 className="product-title">A Project Presentation Platform For You</h2>

              {/* Metrics Row */}
              <div className="superx-metrics-row">
                <div className="metric-item">
                  <span className="metric-number">1200+</span>
                  <span className="metric-label">Participations</span>
                </div>
                <div className="metric-item">
                  <span className="metric-number">200+</span>
                  <span className="metric-label">Projects</span>
                </div>
                <div className="metric-item">
                  <span className="metric-number">20+</span>
                  <span className="metric-label">Domains</span>
                </div>
                <div className="metric-item">
                  <span className="metric-number">5+</span>
                  <span className="metric-label">Startup Partners</span>
                </div>
              </div>

              <button className="product-cta-btn" onClick={() => navigate('/superx')}>
                Know More
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 19L19 5M19 5H9M19 5V15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <div className="C2wProducts_right_col">
              <div className="superx-graphic-wrapper">
                <div className="decor-circle circle-orange"></div>
                <div className="decor-circle circle-green"></div>
                <div className="decor-circle circle-large-green-path"></div>
                <div className="decor-circle circle-small-yellow"></div>
                <div className="decor-circle circle-blue-glow"></div>

                <div className="superx-browser-mockup">
                  <div className="browser-header">
                    <span className="dot red"></span>
                    <span className="dot yellow"></span>
                    <span className="dot green"></span>
                  </div>
                  <div className="browser-content">
                    <video
                      src="/assets/superx/videos/SuperxVideo.mp4"
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (index === 2) {
      return (
        <div className="C2wProducts_slide_layout slide-quizeethon-inner">
          <div className="C2wProducts_slide_content">
            <div className="C2wProducts_left_col">
              <div className="product-logo-wrapper">
                <img src="/assets/quizeethon/landing/QuizeethonLogo.png" alt="quizeethon-logo" className="prod-logo quizeethon-logo-img" />
              </div>
              <div className="quizeethon-think-badge">
                <span className="think-icon">🤔</span>
                <span>THINK MORE, CHOOSE ONE</span>
              </div>
              <h2 className="product-title">Test Your Coding Skill Through Quiz Competitions.</h2>
              <p className="product-description">
                Quiz competition and quick thinking.
              </p>

              <button className="product-cta-btn" onClick={() => navigate('/quizeethon-event')}>
                Know More
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 19L19 5M19 5H9M19 5V15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>

            <div className="C2wProducts_right_col">
              <div className="quizeethon-classroom-wrapper">
                <img src="/assets/images/upcomingCourse/1_quiz.PNG" alt="Quizeethon 1st Rank Winner" className="classroom-img" />

                {/* Floating Winner Badge */}
                <div className="quizeethon-winner-badge">
                  <span className="winner-icon">🏆</span>
                  <div className="winner-info">
                    <span className="winner-title">Quizeethon Winner</span>
                    <span className="winner-subtitle">1st Rank Felicitation</span>
                  </div>
                </div>

                {/* Floating Timer Widget */}
                <div className="quizeethon-timer-widget">
                  <div className="timer-circle-progress">
                    <svg width="40" height="40" viewBox="0 0 40 40">
                      <circle cx="20" cy="20" r="16" stroke="rgba(255,255,255,0.2)" strokeWidth="3" fill="transparent" />
                      <circle cx="20" cy="20" r="16" stroke="#00e676" strokeWidth="3" fill="transparent" strokeDasharray="100" strokeDashoffset="25" />
                    </svg>
                    <span className="timer-icon">⏰</span>
                  </div>
                  <div className="timer-details">
                    <span className="timer-label">Time Left</span>
                    <span className="timer-countdown">04:12</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="C2wProducts_section_wrapper">
      {/* Sticky Stack Layout for Smooth Vertical Pinned Scroll */}
      <div className="C2wProducts_sticky_parent">
        {/* Slide 0: Incubators */}
        <div className="C2wProducts_slide_container slide-incubators">
          {renderSlideContent(0)}
        </div>

        {/* Slide 1: Super-X */}
        <div className="C2wProducts_slide_container slide-superx">
          {renderSlideContent(1)}
        </div>

        {/* Slide 2: Quizeethon */}
        <div className="C2wProducts_slide_container slide-quizeethon">
          {renderSlideContent(2)}
        </div>
      </div>
    </div>
  );
}

export default C2wIncubators;